import { FieldValues, useController } from 'react-hook-form';

import { FormControlInput } from '@/core/components';
import { CustomSelect } from '@/core/components/Select';

export interface EnumSelectControlProps<T extends FieldValues> extends FormControlInput<T> {
  withAsterisk?: boolean;

  label: string;
  description?: string;
  placeholder?: string;

  isDisabled?: boolean;
  allowDeselect?: boolean;

  options: { value: string; label: string; disabled?: boolean }[];
}

export function EnumSelectControl<T extends FieldValues>(props: EnumSelectControlProps<T>) {
  const {
    withAsterisk,
    label,
    placeholder,
    description,
    name,
    isSubmitting,
    isDisabled,
    allowDeselect,
    options,
    control,
  } = props;
  const {
    field,
    fieldState: { error },
  } = useController({ name, control });

  return (
    <CustomSelect
      searchable
      data={options}
      ref={field.ref}
      name={field.name}
      value={field.value}
      onChange={field.onChange}
      label={label}
      description={description}
      placeholder={placeholder ?? label}
      withAsterisk={withAsterisk}
      error={error?.message}
      disabled={isSubmitting || isDisabled}
      allowDeselect={allowDeselect}
      flex={1}
    />
  );
}
